module.exports = __webpack_public_path__ + "static/media/junior_livenew.6d4d4e1f.svg";